import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserSettingsPage from "./UserSettingsPage";
import UserSettingsModal from "../components/UserSettings/UserSettingsModal";

function UserSettingsRoute() {
	const location = useLocation();
	const navigate = useNavigate();
	const { userId } = useParams();
	const hasBackgroundLocation = Boolean(location.state?.backgroundLocation);

	if (!hasBackgroundLocation) {
		return <UserSettingsPage />;
	}

	const handleClose = () => {
		if (window.history.length > 1) {
			navigate(-1);
			return;
		}

		navigate(`/user/${userId}/settings`, { replace: true });
	};

	return <UserSettingsModal onClose={handleClose} />;
}

export default UserSettingsRoute;
